export default {
  baseUrl: process.env.REACT_APP_BASE_URL,
}